import axios from 'axios';

const API_BASE = '/api/sales/expenses';

export const salesExpenseService = {
  getMeta: async () => {
    const response = await axios.get(`${API_BASE}/meta`);
    return response.data;
  },

  getAll: async (params = {}) => {
    const response = await axios.get(API_BASE, { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },

  getDownloadUrl: (id) => `${API_BASE}/${id}/download`,

  submit: async ({ file, notes, amount, receiptDate }) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('notes', notes != null ? String(notes).trim() : '');
    formData.append('amount', amount != null ? String(amount).trim() : '');
    if (receiptDate) formData.append('receipt_date', receiptDate);

    const response = await axios.post(API_BASE, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  updateStatus: async (id, status) => {
    const response = await axios.patch(`${API_BASE}/${id}/status`, { status });
    return response.data;
  },
};
